<template>
   <div class="section section-about" v-if="about != null">
        
        <!-- <aboutFirst v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-about"></aboutFirst> -->
        <aboutSecond v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-location"></aboutSecond>
        <aboutThird v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-around"></aboutThird>
        <aboutFourth v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-fourth"></aboutFourth>
        <!-- <aboutFifth v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-arch"></aboutFifth> -->
        <!-- <aboutSixth v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-improv"></aboutSixth> -->
        <!-- <aboutSeven v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-lobbi"></aboutSeven> -->
        <!-- <aboutGenplan v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-genplan"></aboutGenplan> -->
        <aboutEight v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-about-eight"></aboutEight>
        <aboutNine v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-about-nine"></aboutNine>
        <!-- <aboutTen v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-about-ten"></aboutTen> -->
        <aboutEleven v-waypoint="{ active: true, callback: onWaypoint, options: intersectionOptions }" id="section-about-eleven"></aboutEleven>
    </div>
</template>

<script>
    // import aboutFirst from '@/components/about/about-elems/about-elem-first.vue'
    import aboutSecond from '@/components/about/about-elems/about-elem-second.vue'
    import aboutThird from '@/components/about/about-elems/about-elem-third.vue'
    import aboutFourth from '@/components/about/about-elems/about-elem-fourth.vue'
    // import aboutFifth from '@/components/about/about-elems/about-elem-fifth.vue'
    import aboutSixth from '@/components/about/about-elems/about-elem-sixth.vue'
    import aboutSeven from '@/components/about/about-elems/about-elem-seven.vue'
    // import aboutGenplan from '@/components/about/about-elems/about-elem-genplan.vue'
    import aboutEight from '@/components/about/about-elems/about-elem-eight.vue'
    import aboutNine from '@/components/about/about-elems/about-elem-nine.vue'
    // import aboutTen from '@/components/about/about-elems/about-elem-ten.vue'
    import aboutEleven from '@/components/about/about-elems/about-elem-eleven.vue'
    
    export default {
        name: 'About',
        components: {
            // aboutFirst,
            aboutSecond,
            aboutThird,
            aboutFourth,
            // aboutFifth,
            aboutSixth,
            aboutSeven,
            aboutEight,
            // aboutGenplan,
            aboutNine,
            // aboutTen,
            aboutEleven,
        },
        data () {
            return {
                intersectionOptions: {
                    rootMargin: '0px 0px 0px 0px',
                    threshold: [0.15,0.55]
                }
            }
        },
        computed: {
            about() {
                return this.$store.state.about
            }
        },
        methods: {
            onWaypoint ({ el, going, direction }) {
                if (this.$waypointMap.GOING_IN === going) {
                    el.classList.add('active');
                } 
            }
        },
        mounted() {
            // console.log(this.about)
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/about/about.scss';
    @import '@/styles/components/about/about-respond.scss';
    // @import '@/styles/components/animation/animation-about.scss';
</style>